(function (window) {
  'use strict';

  function parseTimestamp(value) {
    var parts = value.trim().split(':');
    if (parts.length === 3) {
      return parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseFloat(parts[2]);
    }
    return parseInt(parts[0], 10) * 60 + parseFloat(parts[1]);
  }

  function parseVtt(vttText) {
    var cues = [];
    if (!vttText) return cues;

    var body = String(vttText).replace(/\r\n/g, '\n').replace(/^WEBVTT[^\n]*\n/, '').trim();
    body.split(/\n\n+/).forEach(function (block) {
      var lines = block.trim().split('\n');
      if (lines.length < 2) return;

      var timing = lines[0].match(/([\d:.]+)\s*-->\s*([\d:.]+)/);
      if (!timing) return;

      cues.push({
        start: parseTimestamp(timing[1]),
        end: parseTimestamp(timing[2]),
        text: lines.slice(1).join('\n').trim()
      });
    });

    return cues;
  }

  function findCue(cues, time) {
    for (var i = 0; i < cues.length; i++) {
      if (time >= cues[i].start && time < cues[i].end) {
        return cues[i].text;
      }
    }
    return '';
  }

  function initVideoCaptions(video, vttText, label, lang) {
    if (!video || video.dataset.captionsReady === 'true') return;
    video.dataset.captionsReady = 'true';

    var cues = parseVtt(vttText);
    if (!cues.length) return;

    var container = video.closest('.video-wrapper-container') || video.parentElement;
    if (!container) return;

    if (window.VTTCue) {
      try {
        var track = video.addTextTrack('captions', label || 'English', lang || 'en');
        track.mode = 'hidden';
        cues.forEach(function (cue) {
          track.addCue(new VTTCue(cue.start, cue.end, cue.text));
        });
      } catch (e) {}
    }

    var display = document.createElement('div');
    display.className = 'video-captions-display';
    display.setAttribute('aria-live', 'polite');
    display.setAttribute('aria-atomic', 'true');
    display.hidden = true;

    var ccBtn = document.createElement('button');
    ccBtn.type = 'button';
    ccBtn.className = 'video-captions-toggle';
    ccBtn.setAttribute('aria-label', 'Show captions');
    ccBtn.setAttribute('aria-pressed', 'false');
    ccBtn.textContent = 'CC';

    container.appendChild(display);
    container.appendChild(ccBtn);

    var captionsOn = false;

    function updateCaptions() {
      if (!captionsOn) {
        display.hidden = true;
        display.textContent = '';
        return;
      }

      var text = findCue(cues, video.currentTime);
      display.textContent = text;
      display.hidden = !text;
    }

    ccBtn.addEventListener('click', function () {
      captionsOn = !captionsOn;
      ccBtn.setAttribute('aria-pressed', captionsOn ? 'true' : 'false');
      ccBtn.setAttribute('aria-label', captionsOn ? 'Hide captions' : 'Show captions');
      ccBtn.classList.toggle('is-active', captionsOn);
      updateCaptions();
    });

    video.addEventListener('timeupdate', updateCaptions);
    video.addEventListener('seeked', updateCaptions);
  }

  function initFromRemote(video, url, label, lang) {
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Captions fetch failed');
        return response.text();
      })
      .then(function (vttText) {
        initVideoCaptions(video, vttText, label, lang);
      })
      .catch(function () {});
  }

  window.RandolphVideoCaptions = {
    init: initVideoCaptions,
    initFromRemote: initFromRemote
  };
})(window);
